import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { leadershipQuotes } from '../data/mock';

const QuoteModal = () => {
  const [open, setOpen] = useState(false);
  const [currentQuote, setCurrentQuote] = useState(null);

  useEffect(() => {
    // Show modal on page load
    const showTimer = setTimeout(() => {
      const randomQuote = leadershipQuotes[Math.floor(Math.random() * leadershipQuotes.length)];
      setCurrentQuote(randomQuote);
      setOpen(true);
    }, 800);

    // Auto-close after 4 seconds
    const closeTimer = setTimeout(() => {
      setOpen(false);
    }, 4800);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(closeTimer);
    };
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl border-none bg-gradient-to-br from-slate-900 to-slate-800 text-white shadow-2xl">
        <div className="p-8 text-center">
          <div className="mb-6">
            <svg className="mx-auto h-12 w-12 text-amber-400" fill="currentColor" viewBox="0 0 24 24">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
            </svg>
          </div>
          {currentQuote && (
            <>
              <p className="mb-6 text-xl font-light leading-relaxed md:text-2xl">
                {currentQuote.quote}
              </p>
              <p className="text-sm font-medium uppercase tracking-wider text-amber-400">
                — {currentQuote.author}
              </p>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuoteModal;
